module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/il1wCJ/tc-custom/9780547563893.jpg?1736952367146",
      "alt": "This image is the cover for the book Island of the Day Before"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Island of the Day Before\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A 17th century Italian nobleman is marooned on an empty ship in this “astonishing intellectual journey\" by the author of "), _c('i', [_vm._v("Foucault’s Pendulum")]), _vm._v(" ("), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In the year 1643, a violent storm in the South Pacific leaves Roberto della Griva shipwrecked—on a ship. Swept from the "), _c('i', [_vm._v("Amaryllis")]), _vm._v(", he has managed to pull himself aboard the "), _c('i', [_vm._v("Daphne")]), _vm._v(", anchored in the bay of a beautiful island. The ship is fully provisioned, he discovers, but the crew is missing."), _c('br'), _c('br'), _vm._v(" As Roberto explores the different cabinets in the hold, he looks back on various episodes from his life: Ferrante, his imaginary evil brother; the siege of Casale, that meaningless chess move in the Thirty Years' War in which he lost his father and his illusions; and the lessons given him on Reasons of State, fencing, the writing of love letters, and blasphemy."), _c('br'), _c('br'), _vm._v(" In this “intellectually stimulating and dramatically intriguing” novel, Umberto Eco conjures a young dreamer searching for love and meaning; and an old Jesuit who, with his clocks and maps, has plumbed the secrets of longitudes, the four moons of Jupiter, and the Flood ("), _c('i', [_vm._v("Chicago Tribune")]), _vm._v(").\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Umberto Eco\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (hmhbooks.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0